<template>
    <div>
       <a-row :gutter="16">
           <a-col :span="8">
                <v-multi
                    title="Collection Queue"
                    v-model="member_type[COLLECTION]"
                    :userList="collectionList"
                    :loading="member_loading[COLLECTION]"
                    @confirm="addMember(COLLECTION, $event)"
                    @delete="deleteMember(COLLECTION, $event)"
                />
           </a-col>
           <!-- <a-col :span="8">
                <v-multi
                    title="Credit Review Queue"
                    v-model="member_type[APPROVAl]"
                    :userList="approvalList"
                    :loading="member_loading[APPROVAl]"
                    @confirm="addMember(APPROVAl, $event)"
                    @delete="deleteMember(APPROVAl, $event)"
                />
           </a-col>
           <a-col :span="8">
                <v-multi
                    title="Reminder Queue"
                    v-model="member_type[REMIND]"
                    :userList="remindList"
                    :loading="member_loading[REMIND]"
                    @confirm="addMember(REMIND, $event)"
                    @delete="deleteMember(REMIND, $event)"
                />
           </a-col> -->
       </a-row>
    </div>
</template>
<script>
    import { getRemindUser } from '@/webpublicapi/remind';
    import { getExamineUser } from '@/webpublicapi/approval';
    import { addQueueList, deleteQueueList, getQueueList, getCollectionUser } from '@/webpublicapi/platformCollection';
    import vMulti from '../operation/modules/MultiSelector'

    export default {
        components: {
            vMulti,
        },
        data () {
            return {
                collectionList: [],
                remindList: [],
                approvalList: [],
                COLLECTION: 2,
                REMIND: 3,
                APPROVAl: 1,
                member_type: {
                    1: [],
                    2: [],
                    3: [],
                },
                member_loading: {
                    1: true,
                    2: true,
                    3: true,
                }
            }
        },
        mounted () {
            getCollectionUser().then(res => {
                if (res.code == 1000) {
                    this.collectionList = (res.data || []);
                } else {
                    this.$message.error('System Busy')
                }
            });
            // getRemindUser().then(res => {
            //     if (res.code == 1000) {
            //         this.remindList = (res.data || []);
            //     } else {
            //         this.$message.error('System busy')
            //     }
            // });
            // getExamineUser().then(res => {
            //     if (res.code == 1000) {
            //         this.approvalList = (res.data || []);
            //     } else {
            //         this.$message.error('System busy')
            //     }
            // });
            this.getMember(this.COLLECTION);
            // this.getMember(this.APPROVAl);
            // this.getMember(this.REMIND);
        },
        methods: {
            addMember (type, list) {
                this.member_loading[type] = true;
                const userIds = list.map(item => item.userId);
                addQueueList({userIds, type}).then(res => {
                    if(res.code == 1000) {
                        this.$message.success(this.$t('success'));
                        this.getMember(type);
                    } else {
                        this.$message.error('System Busy')
                    }
                })
            },
            deleteMember (type, { userId }) {
                this.member_loading[type] = true;
                deleteQueueList({ userId, type}).then(res => {
                    if (res.code == 1000) {
                        this.$message.success(this.$t('success'))
                        this.getMember(type);
                    } else {
                        this.$message.error('System Busy')
                    }
                })
            },
            getMember (type) {
                this.member_loading[type] = true;
                getQueueList({type}).then(res => {
                    if (res.code == 1000) {
                        this.member_type[type] = res.data || [];
                    } else {
                        this.$message.error('System Busy')
                    }
                    this.member_loading[type] = false;
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    body {
        background: #fff;
    }
</style>